// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9uJaX","title":"Header_title__7h6fo","left":"Header_left__30iQs","clinicName":"Header_clinicName__JHyz6"};